import React from 'react'
import IconifyIcon from '../wrapper/IconifyIcon'
import { logEvent } from '../../config/firebase'
import './TelegramPromoCta.css'

export const POLYMIDAS_URL = 'https://t.me/polymarket_market_aim_bot'

const TelegramPromoCta = ({ className = '', compact = false, context = 'generic' }) => {
  const handleClick = () => {
    logEvent('telegram_cta_click', {
      bot: 'polymidas',
      placement: context,
    })
  }

  return (
    <a
      className={`telegram-promo-cta ${compact ? 'is-compact' : ''} ${className}`.trim()}
      href={POLYMIDAS_URL}
      onClick={handleClick}
      rel="noopener noreferrer"
      target="_blank"
    >
      <span className="telegram-promo-icon" aria-hidden="true">
        <IconifyIcon icon="logos:telegram" width="20" />
      </span>
      <span className="telegram-promo-copy">
        <strong>PolyMidas</strong>
        <small>Alertas Polymarket e smart money</small>
      </span>
      <span className="telegram-promo-action">
        Abrir bot
        <IconifyIcon icon="solar:arrow-right-up-linear" width="15" />
      </span>
    </a>
  )
}

export default TelegramPromoCta
